import React from 'react'
import ReportElementToggledBarChart from './ReportElementToggledBarChart'
import ReportElementStackedBarChart from './ReportElementStackedBarChart'
import useReportElementChart from 'hooks/useReportElementChart'
import { ReportElementProps } from './ReportElement'

const ReportElementBarChart: React.FC<ReportElementProps> = ({
  reportId,
  element,
  report,
  sectionId,
  favorites = false,
  print = false,
  onUpdateFavorites,
}) => {
  const { parsedContent, data } = useReportElementChart(element, reportId)

  if (data.no_data) {
    return null
  }

  const chartType = parsedContent.bar_chart_type
  if (['normal', 'toggledBarChart'].includes(chartType)) {
    return (
      <ReportElementToggledBarChart
        {...{
          reportId,
          element,
          report,
          sectionId,
          favorites,
          print,
          onUpdateFavorites,
        }}
      />
    )
  }
  if (['stacked', 'stackedBarChart'].includes(chartType)) {
    return (
      <ReportElementStackedBarChart
        {...{
          reportId,
          element,
          report,
          sectionId,
          favorites,
          print,
          onUpdateFavorites,
        }}
      />
    )
  }
  return null
}

export default ReportElementBarChart
